'use client'

import { Link, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import { AccountsCatalogNav } from '@/components/accounts-catalog-nav'
import { useAuth } from '@/components/auth-provider'
import { isBusinessAccountsPath } from '@/lib/business-app-path'
import { cn } from '@/lib/utils'

export default function SiteNav() {
  const { pathname } = useLocation()
  const { status } = useAuth()
  const isAuthed = status === 'authenticated'
  const [isVisible, setIsVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const onAccountsSelection =
    pathname === '/accounts' || isBusinessAccountsPath(pathname)

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset

      if (scrolled > 100) {
        if (scrolled > lastScrollY && isVisible) {
          setIsVisible(false)
        } else if (scrolled < lastScrollY && !isVisible) {
          setIsVisible(true)
        }
      } else {
        setIsVisible(true)
      }
      setLastScrollY(scrolled)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isVisible, lastScrollY])

  return (
  <header
    className={cn(
      'sticky top-0 z-50 bg-cfb-light/95 backdrop-blur supports-[backdrop-filter]:bg-cfb-light/80 border-b border-cfb-shadow shadow-sm transition-transform duration-300',
      onAccountsSelection ? 'block' : 'hidden md:block',
      isVisible ? 'translate-y-0' : '-translate-y-full',
    )}
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center">
            <a
              href="https://www.climatefirstbank.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Climate First Bank website"
              className="inline-flex"
            >
              <img
                src="/cfb-logo-horizontal.png"
                alt="Climate First Bank"
                width={200}
                height={47}
                className="h-10 w-auto"
              />
            </a>
          </div>
          <nav className="text-sm text-gray-600 flex items-center gap-4 sm:gap-6">
            <AccountsCatalogNav />
            <Link
              to={isAuthed ? '/account/portal' : '/login'}
              className="bg-brand text-cfb-light px-4 py-1.5 shadow-sm hover:bg-brand-hover hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
            >
              {isAuthed ? 'My Account' : 'Sign in'}
            </Link>
          </nav>
        </div>
      </div>
    </header>
  )
}
